import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function MentalYorgunlukTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['mental-yorgunluk-testi']} />;
}
